/* eslint-disable no-unused-vars */
import React, { Component } from 'react'
import { Row, Col, Table, Checkbox, Select, Form, notification, Spin, Space, Button, Drawer, InputNumber, Input, /*Popconfirm,*/ Switch, Typography } from 'antd'
import { FilterOutlined, LogoutOutlined, ArrowLeftOutlined, HomeOutlined, QuestionCircleOutlined } from '@ant-design/icons'
import { CountUp } from '../../utils/timer'
import '../warehouse/index.css'
import './index.css'
import Http from '../../utils/http'
import { COOKIE, getCookie, logout, pageHandler } from '../../utils/cookie'
import { constants, timezone } from '../../constants/constants'
import { cloneDeep } from 'lodash'
import moment from 'moment'
import { format_gate, cacheRetrieve } from '../../utils/common'
import Cookies from 'universal-cookie'
import AppSyncEventManager from '../../utils/AppSyncEventManager'

const { Option } = Select
const { Text } = Typography
const CHARNUM3COMMA = '^[0-9a-zA-Z]{3}(,([0-9a-zA-Z]{3}))*$'
const CHARNUM3COMMAerr = 'field must contain 3 character alpha-numeric value seperated by a comma'

let FSU_LIST = ['RCF', 'FPS', 'MAN']

function formatAWBNo(awb) {
  let result = ''
  if (awb) {
    result = [awb.slice(0, 3), '-', awb.slice(3)].join('')
  }
  return result
}

function getTimeDifferenceInMinutes(difference) {
  if (difference) {
    return moment().diff(difference, 'minutes')
  } else return 0
}
class ServiceRecoveryDashboard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      station: getCookie(COOKIE.STATION),
      role: getCookie(COOKIE.ROLE),
      logintype: getCookie(COOKIE.LOGINTYPE),
      clock: '',
      data: [],
      loading: false,
      tableBodyFontSize: localStorage.getItem(`Recovery_${new Cookies().get('station')}`),
      defaultFontSize: 'clamp(14px,1.7vw,1.7vw)'
    }
    this._queue = []
    this._isBusy = false
    this.myRef = React.createRef()
    this.tableRef = React.createRef()
    this.eventManager = null
  }
  componentDidMount() {
    this.fetchList()
  }

  fetchList = async () => {
    // Implementation for fetching the list goes here
    let headers = { station: this.state.station }
    await Http.get('service_awbs_list', { headers: headers }).then(resp => {
      if (resp?.status === 200) {
        if (resp?.data?.data?.length > 0) {
          this.setState({ data: resp?.data?.data })
        } else {
          this.setState({ data: [] })
        }
      }
    })
  }
  render() {

    const awb_columns = [
      {
        title: 'Flight #',
        dataIndex: 'flight_no',
        key: 'flight_no',
        align: 'left',
        className: 'pl-1vw w-10vw',
        render: (_, record) => (
          <span>{record?.flights_in?.flight_no ? record?.flights_in?.flight_no +'/'+ moment(record?.flights_in?.flight_date).format('DDMMMYYYY') : 'N/A'}</span>
        )
      },
      {
        title: 'AWB',
        dataIndex: 'awb_no',
        key: 'awb_no',
        className: 'w-22vw',
        render: (_, record) => (
          <span>{record?.awb_no ? record?.awb_no : 'N/A'}</span>
        )
      },
      {
        title: 'Org-Dest',
        dataIndex: 'org_dest',
        key: 'org_dest',
        className: 'w-22vw',
        render: (_, record) => (
          <span>{record?.org +'-'+ record?.dest}</span>
        )
      },
      // {
      //   title: 'Booked Flight',
      //   dataIndex: 'booked_flight',
      //   key: 'booked_flight',
      //   className: 'w-22vw',
      //   render: (_, record) => (
      //     <span>{record?.segs_out?.flight_no ? record?.segs_out?.flight_no + moment(record?.segs_out?.flight_date).format('DDMMMYYYY') : 'N/A'}</span>
      //   )
      // },
      {
        title: 'Flight OUT',
        dataIndex: 'flight_out',
        key: 'flight_out',
        className: 'w-22vw',
        render: (_, record) => (
          <span>{record?.flights_out?.flight_no ? record?.flights_out?.flight_no +'/'+ moment(record?.flights_out?.flight_date).format('DDMMMYYYY') : 'N/A'}</span>
        )
      }
    ]

    return (
      <div className='warehouse-screen recovery-dashboard'>
        <div
          className='recovery-content'>
          <div className='text-right f-spacebtw'>
            <div className='no-print'>
              {this.state.role?.toUpperCase() === 'WAREHOUSE TV' ?
                <div className='d-flex'>
                  {
                    this.state.logintype && this.state.logintype === 'DashTV' ? null :
                      <div className='mr-1vw'>
                        <Button className='custom-icon-button warehouse-filter' type='primary' shape='circle' icon={<ArrowLeftOutlined />} size='large' onClick={() => window.location.href = '/landing-page'} />
                        <p className='btn-text'>Back</p>
                      </div>
                  }
                  <div>
                    <Button className='custom-icon-button warehouse-filter rotate-180' type='primary' shape='circle' icon={<LogoutOutlined />} size='large' onClick={this.handleRedirect} />
                    <p className='btn-text'>Signout</p>
                  </div>
                </div>
                :
                <div>
                  <Button className='custom-icon-button warehouse-filter' type='primary' shape='circle' icon={<HomeOutlined />} size='large' onClick={this.handleRedirect} />
                  <p className='btn-text'>Home</p>
                </div>
              }
            </div>
            <h1 className='dash-title mr-0 dash-loc'>{this.state.station}</h1>
          </div>
          <div className='clock-container'>
            <Text className='clock-text'>
              {this.state.clock}
            </Text>
          </div>
          <h1 className='text-center'><span className='dash-title'>Service Recovery Dashboard</span></h1>
          <Row
            gutter={[
              {
                xs: 0,
                sm: 0,
                md: 0,
                lg: 0,
              },
              {
                xs: 0,
                sm: 0,
                md: 0,
                lg: 0,
              },
            ]}
          >
            <Col xs={24} sm={24} md={24} lg={24} className='' ref={this.tableRef}>
              {
                <Spin spinning={this.state.loading}>
                  {this.state.data?.length === 0 && <Table
                    className='components-table-demo-nested warehouse-table recovery-table nth-td-p-0'
                    columns={awb_columns}
                    dataSource={this.state.data}
                    pagination={false}
                  />}

                  <div>
                    {this.state.data?.length > 0 && <Table
                      className='components-table-demo-nested warehouse-table recovery-table nth-td-p-0'
                      columns={awb_columns}
                      dataSource={this.state.data}
                      pagination={false}
                      rowKey='id'
                      onRow={() => {
                        return { style: { fontSize: `${this.state.tableBodyFontSize === null || this.state.tableBodyFontSize === 'null' ? this.state.defaultFontSize : `${this.state.tableBodyFontSize}vw`}` }, }
                      }}
                      onHeaderRow={() => {
                        return { style: { fontSize: `${this.state.tableBodyFontSize === null || this.state.tableBodyFontSize === 'null' ? this.state.defaultFontSize : `${this.state.tableBodyFontSize}vw`}`, }, }
                      }}
                    />}
                  </div>

                </Spin>
              }
            </Col>
          </Row>
        </div>
      </div>
    )
  }
}

export default ServiceRecoveryDashboard
